module.exports = __webpack_public_path__ + "img/godlo_polski.12b83261.png";